const WebsocketTransport = require('websocket-transport');

module.exports = fox => {
	var _ = {
		EVENT_INBOX_PRIVATE: 'inbox_private',
		EVENT_INBOX_PUBLIC: 'inbox_public',
		EVENT_INBOX_SERVICE: 'inbox_service'
	};

	fox.registerWidget('UserChatController', {
		_send: function (params) {
			this._transport.send(params);

			return this;
		},

		configure: function () {
			this.lastRequest = null;

			this.registerOptions('', {
				serverhost: 'chat.modelcentro.com',
				handleWom: {
					fingerprintRecieved: {
						widget: '@root',
						event: 'exodentity_fingerprint_recieved',
						callback: ({ fingerprint }) => {
							const pm = this.wom1('@root #permissionManager');

							if (pm && pm.hasAccess('guestActual')) {
								const id = `guest_${fox.getStringSimpleHash(fingerprint, 36)}`;

								if (id !== this.userId) {
									return this.reconnect();
								}
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			const pm = this.wom1('@root #permissionManager');
			const getId = () => {
				let id;

				if (pm && !fox.isEmpty(pm.getMemberInfo())) {
					id = `${pm.getMemberInfo('id')}`;
				} else if (fox.site.member) {
					id = `${fox.site.member.getObjectValue('id')}`;
				} else {
					const exoUid = fox.exodentity && fox.exodentity.getSavedUid();
					
					id = `guest_${exoUid ? fox.getStringSimpleHash(exoUid, 36) : fox.random(1000, 100000)}`;
				}

				return id;
			}

			this.userId = getId();

			this._transport = new WebsocketTransport({
				host: this.getOption('serverhost'),
				transport: window.io,
				getId: () => {
					const id = getId();

					if (this.userId !== id)
						this.userId = id;

					return id;
				},
				onMessage: message => this._inbox(message)
			});

			this._transport.connect();

			this.callParent('init', arguments);
		},

		_inbox: function (msg) {
			if (!msg.hasOwnProperty('mtype')) {
				if (~msg.to.indexOf('@')) {
					this.dispatchEvent(_.EVENT_INBOX_PRIVATE, msg);
				} else {
					this.dispatchEvent(_.EVENT_INBOX_PUBLIC, msg);
				}
			} else if (msg.mtype === 'service') {
				this.proxyServiceMessages(msg);
			}
		},

		reconnect() {
			const reconnectPromise = this.wait('chat_join');
			this._transport.disconnect();
			return reconnectPromise;
		},

		createRoom(id, history) {
			if (id === undefined) {
				id = '_default';
			}

			var params = {
				method: 'room',
				action: 'create',
				alias: id
			};

			if (history) {
				params.plugins = {history: {}};
			}

			return this._send(params);
		},

		joinRoom(id) {
			const joinPromise = this._withDelayedResolve(this.wait('room_join'));

			this._send({
				method: 'room',
				action: 'join',
				alias: id
			});

			return joinPromise;
		},

		leaveRoom(id) {
			const leavePromise = this._withDelayedResolve(this.wait('room_leave'));

			this._send({
				method: 'room',
				action: 'leave',
				alias: id
			});

			return leavePromise;
		},

		prepareUserObject(id) {
			var parts = id.split('@');

			return {
				uid: parts[0],
				entry: parts[1]
			};
		},

		getRoomUsers(id) {
			const roomUsersPromise = this.wait('room_members');

			this._send({
				method: 'room',
				action: 'getMembersList',
				alias: id
			});

			return roomUsersPromise.then(function (resp) {
				var members = resp.params.members.map(this.prepareUserObject);

				return fox.Promise.resolve(members);
			}.bind(this));
		},

		getRoomHistory(id) {
			const roomHistoryPromise = this.wait('room_history');

			this._send({
				method: 'room',
				action: 'history',
				alias: id
			});

			return roomHistoryPromise.then(function (resp) {
				return resp.params.messages;
			}.bind(this));
		},

		sendMessage(msg, to) {
			var params = fox.mixin({
				method: 'message',
				to: to.toString()
			}, msg);

			this._send(params);
		},

		proxyServiceMessages(msg) {
			return this.dispatchEvent(msg.alias, msg);
		},

		_withDelayedResolve(promise, delay = 400) {
			return new fox.Promise((resolve) => {
				const timeout = setTimeout(resolve, delay);

				return promise.then((resp) => {
					clearTimeout(timeout);

					return resolve(resp);
				});
			});
		}
	}, 'Controller');

};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/widget/UserChatController.es.js